// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_process_body = /** @type {(inputs: {}) => string} */ () => {
	return `Once we receive and inspect your return, we will process your refund within 2 weeks. The refund will be issued to your original payment method.`
};

const el_refunds_process_body = /** @type {(inputs: {}) => string} */ () => {
	return `Μόλις παραλάβουμε και ελέγξουμε την επιστροφή σας, θα επεξεργαστούμε την επιστροφή χρημάτων εντός 2 εβδομάδων. Η επιστροφή θα γίνει στον αρχικό τρόπο πληρωμής.`
};

const ru_refunds_process_body = /** @type {(inputs: {}) => string} */ () => {
	return `После получения и проверки возврата мы обработаем возврат средств в течение 2 недель. Возврат будет произведён на исходный способ оплаты.`
};

const he_refunds_process_body = /** @type {(inputs: {}) => string} */ () => {
	return `לאחר שנקבל ונבדוק את ההחזרה, נעבד את ההחזר הכספי תוך שבועיים. ההחזר יבוצע לאמצעי התשלום המקורי.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_process_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_process_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_process_body", locale)
	if (locale === "en") return en_refunds_process_body(inputs)
	if (locale === "el") return el_refunds_process_body(inputs)
	if (locale === "ru") return ru_refunds_process_body(inputs)
	if (locale === "he") return he_refunds_process_body(inputs)
	return "refunds_process_body"
};